function findPageType(urlConfig, url) {
    for (let urlType in urlConfig) {
        const deconstructedUrl = deconstructUrl(urlConfig[urlType].deconstruct, url);
        if (deconstructedUrl) {
            return {
                page: urlType,
                params: deconstructedUrl
            };
        }
    }
    return;
}

function constructUrl(template, params = {}) {
    let url = template;
    for (let key in params) {
        url = url.replace(`{{${key}}}`, params[key]);
    }
    return url;
}

function deconstructUrl(deconstructRules, url) {
    let response;
    // "PARAMETERS" are not required url component hence minus 1
    const requiredParams = deconstructRules.groups.length - 1;
    let numberOfParams = 0;

    const escapedRegex = escapeRegex(deconstructRules.regex);
    let components = url.match(escapedRegex);

    // check regex has found entries, remove first which is full URL
    if (components && components.length > 1) {
        components.shift();
        response = {};

        // build parms object
        components.forEach((component, i) => {
            const key = deconstructRules.groups[i];
            if (key) {
                response[deconstructRules.groups[i]] = component;
                if (component && component !== '') {
                    numberOfParams++;
                }
            }
        });

        // only mark valid if all but "PARAMETERS" are populated
        if (numberOfParams < requiredParams) {
            return undefined;
        }

        // remove ignored values, done at the end to retain if valid url
        for (let key in response) {
            if (key.toLowerCase() === 'ignore') {
                delete response[key];
            }
        }
    }

    return response;
}

// this is gross but best way I could think to escape the regex
function escapeRegex(regex) {
    return regex.replace(/\\/g, '\\\\').replace(/\//g, '\\/');
}

export { findPageType, constructUrl, deconstructUrl, escapeRegex };
